import { Button, Drawer, notification, Row, Space, Spin, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Select1, TextArea1 } from '../../../Components/FormComponents/InputFields';
import { AddEmployeeApi, ExcelUploadApi } from '../../../Services/GeoTag';
import { MdInbox } from 'react-icons/md';
import { download } from '../../../Services/GeneralFunctions';
import { LoadingOutlined } from '@ant-design/icons'
import { useOutletContext } from 'react-router-dom';

const { Dragger } = Upload;

 export default function RaiseTicket ( { open, onClose, getEmployeesData } ) {
    const {dropDowns} = useOutletContext();

    const { control, formState: {errors}, handleSubmit, reset } = useForm();
    const [api, contextHolder] = notification.useNotification();

    const [ submitLoader, setSubmitLoader ] = useState(false);


    const onSubmit = async (val) => {
      console.log(val);
      // try {
      //   const data = await AddEmployeeApi(val);

      //   if (data.data.success) {
      //     api.success({
      //       message: data.data.message,
      //       placement: 'top'
      //     });
      //     getEmployeesData();
      //     onClose();
      //   }
      //   else {
      //     api.error({
      //       message: data.data.message,
      //       placement: 'top'
      //     });
      //   }
      // }
      // catch (err) {
      //   api.error({
      //     message: err.message,
      //     placement: 'top'
      //   });
      // }
    }

    

    const onPdfUpload = (val, setFileList) => {

      if ( val[0].type==='application/pdf' ) {
        setFileList(val);

        return false;

      }
      else {

        return Upload.LIST_IGNORE;
      }
    }

    useEffect(() => {
      reset();
    }, [onClose])

  return (
    <>
      { contextHolder }
      <Drawer
        title="Raise a Ticket"
        onClose={onClose}
        open={open}
        contentWrapperStyle={{width: '100vw'}}
        bodyStyle={{
          paddingBottom: 80,
          
        }}
        footer={
          <Space size='middle'>
            <Button size='large' onClick={onClose}>Cancel</Button>
            <Button size='large' onClick={handleSubmit(onSubmit)} type="primary">
              { submitLoader && <Spin className='mr-2 mb-2' size='default' indicator={<LoadingOutlined className='text-light' />} spinning={true}/>}
              Submit
            </Button>
          </Space>
        }
        footerStyle={{textAlign: 'right'}}
      >
            <Row>
                <Select1 control={control} errors={errors} validations={ { required: true } } id='typeOfIssue' name='Type of Issue' options={dropDowns && dropDowns.ISSUE_TYPES} />
                <TextArea1 control={control} errors={errors} validations={ { required: true } } id='remarks' name='Remarks' />

                <Controller
                  name='policyPdf'
                  control={control}
                  defaultValue={[]}
                  rules={{ required: true }}
                  render={({ field }) => 
                    <Dragger 
                      className='w-100 mx-3 mt-4' beforeUpload={(temp, val) => onPdfUpload(val, field.onChange)} 
                      listType='picture'
                      accept='application/pdf'
                      maxCount={1}
                      fileList={field.value}
                      onRemove={() => field.onChange([])}
                    >
                      <p className="ant-upload-drag-icon">
                        <MdInbox className='fs-1 text-info' />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">
                        Support for a single PDF file.
                      </p>
                    </Dragger>
                  }
                />
                {errors && errors.policyPdf?.type === 'required' && <span className='mx-3 text-danger' style={{ fontSize: '13px', bottom: '-20px'}} role="alert">Please Select a File.</span>}

            </Row>
      </Drawer>
    </>
  );
};